import store from '../store'

function importLayouts (view) { // Lazy Loading Route
  return (resolve) => import(
  '@/views/layouts/' + view + '.vue'
  ).then(resolve)
}

// function importLayouts (view) { // Lazy Loading Route
//   return (resolve) => import(
//     `@/views/layouts/${view}.vue`
//   ).then(resolve)
// }

function importPages ({ subFolder = null, view }) {
  if (subFolder) {
    return (resolve) => import(
      '@/views/' + subFolder + '/' + view + '.vue'
    ).then(resolve)
  }

  return (resolve) => import(
    '@/views/' + view + '.vue'
  ).then(resolve)
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.authorized) {
    next()
    return
  }

  next('/')
}

/* Main layouts */
const mainContainer = importLayouts('AppMain')
const loginContainer = importLayouts('AppLogin')

/* Main views */
const homeView = importPages({ view: 'Home' })

const companyView = importPages({ subFolder: 'companies', view: 'Company' })
const companyQuotaView = importPages({ subFolder: 'companies', view: 'CompanyQuota' })
const fundBucketView = importPages({ subFolder: 'buckets', view: 'FundBucket' })
const fundBucketTypeView = importPages({ subFolder: 'buckets', view: 'FundBucketType' })
const fundBucketHasTypeView = importPages({ subFolder: 'buckets', view: 'FundBucketHasType' })
const fundBucketItemView = importPages({ subFolder: 'buckets', view: 'FundBucketItem' })
const fundBucketItemDescriptionView = importPages({ subFolder: 'buckets', view: 'FundBucketItemDescription' })
const paymentChannelView = importPages({ subFolder: 'payments', view: 'PaymentChannel' })
const paymentChannelTypeView = importPages({ subFolder: 'payments', view: 'PaymentChannelType' })
const branchPaymentChannelView = importPages({ subFolder: 'payments', view: 'BranchPaymentChannel' }) 
const loginView = importPages({ subFolder: 'auth', view: 'Index' })
const permissionView = importPages({ view: 'NoPermission' })
const taxView = importPages({ subFolder: 'taxes', view: 'Tax' })

export default [
  { // catch-all route
    path: '*',
    redirect: {
      path: '/home',
    },
  },
  { // default route
    path: '/',
    redirect: {
      path: '/home',
    },
  },
  {
    path: '/login',
    component: loginContainer,
    beforeEnter: ifNotAuthenticated, // Per-Route Guard
    children: [
      {
        path: '',
        name: 'login',
        component: loginView,
      },
    ],
  },
{   
    path: '',
    component: mainContainer,
    meta: {
        name: '',
        requiresAuth: true,
    },
    children: [
        {
          path: '/permissions/deny',
          name: 'Permission Denied',
          component: permissionView,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: '/company',
          component: companyView,
          meta: {
            requiresAuth: true,
            permission: 'company view',
          },
        },
        {
          path: '/company-quota',
          component: companyQuotaView,
          meta: {
              requiresAuth: true,
              permission: 'company quota view',
          },
        },
        {
          path: '/fund-bucket',
          component: fundBucketView,
          meta: {
              requiresAuth: true,
              permission: 'fund bucket view',
          },
        },
        {
          path: '/fund-bucket-item',
          component: fundBucketItemView,
          meta: {
              requiresAuth: true,
              permission: 'fund bucket item view',
          },
        },
        {
          path: '/fund-bucket-type',
          component: fundBucketTypeView,
          meta: {
              requiresAuth: true,
              permission: 'fund bucket type view',
          },
        },
        {
          path: '/fund-bucket-has-type',
          component: fundBucketHasTypeView,
          meta: {
              requiresAuth: true,
              permission: 'fund bucket has type view',
          },
        },
        {
          path: '/fund-bucket-item-description',
          component: fundBucketItemDescriptionView,
          meta: {
              requiresAuth: true,
              permission: 'fund bucket item description view',
          },
        },    
        {
            path: '/payment',
            component: paymentChannelView,
            meta: {
                requiresAuth: true,
                permission: 'payment channel view',
            },
        },
        {
          path: '/payment-channel-type',
          component: paymentChannelTypeView,
          meta: {
              requiresAuth: true,
              permission: 'payment channel type view',
          },
      },
      {
        path: '/branch-payment-channel',
        component: branchPaymentChannelView,
        meta: {
            requiresAuth: true,
            permission: 'branch payment channel view',
        },
      },
      {
        path: '/tax',
        component: taxView,
        meta: {
            requiresAuth: true,
            permission: 'tax setting view',
        },
      },
      {
        path: '/home',
        component: homeView,
        meta: {
            requiresAuth: true,
        },
      },
    ],
  },
]
